export enum EmailType {
  Invitation = 'invitation',
  Reminder = 'reminder',
  Personalized = 'personalized',
}
